
import { Component } from '@angular/core';

@Component({
  selector: 'services',
  templateUrl: '../../templates/partials/services-service.html'
})
export class ServicesServiceComponent{

    public servicesTab: string = "next";

    setHistoryTab(){
        this.servicesTab = "history";
    }
    setNextTab(){
        this.servicesTab = "next";
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/services-service.component.ts